import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterComprometimentos() {
        return axiosJwt
            .get(`${api}/gescon/gestores/servicos/comprometimentos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentosPorVencimentos() {
        return axiosJwt
            .get(`${api}/gescon/gestores/servicos/comprometimentosvencimentos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexos(fornecedorId, codContrato, idComprometimento) {
        let url = `${api}/gescon/gestores/servicos/comprometimentos/${idComprometimento}/anexos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexosTipos() {
        let url = `${api}/gescon/gestores/servicos/comprometimentos/anexos/tipos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirComprometimentoAnexo(codContrato, anexo) {
        const formData = new FormData()
        formData.append('idComprometimento', anexo.idComprometimento)
        formData.append('tipoId', anexo.tipoId)
        formData.append('descritivo', anexo.descritivo)
        formData.append('arquivo', anexo.arquivo)

        return axiosJwt
            .post(
                `${api}/gescon/gestores/servicos/comprometimentos/${anexo.idComprometimento}/anexos/`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexo(codContrato, idComprometimento, comprometimentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/gescon/gestores/servicos/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirComprometimentoAnexo(codContrato, idComprometimento, comprometimentoAnexoId) {
        let url = `${api}/gescon/gestores/servicos/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`
        return axiosJwt
            .delete(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reprovarComprometimento(reprovacao) {
        let url = `${api}/gescon/gestores/servicos/comprometimentos/${reprovacao.idComprometimento}/reprovar`
        return axiosJwt
            .post(url, reprovacao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarComprometimento(aprovacao) {
        let url = `${api}/gescon/gestores/servicos/comprometimentos/${aprovacao.idComprometimento}/aprovar`
        return axiosJwt
            .post(url, aprovacao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAprovadores(codContrato, idComprometimento) {
        let url = `${api}/gescon/gestores/servicos/comprometimentos/${idComprometimento}/aprovadores`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
